module.exports = __webpack_public_path__ + "static/media/Moj-8.919f21bd.PNG";